import { Dropdown, MenuProps } from "antd";
import i18next from "i18next";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { langList } from "src/lang/langList";

import * as styles from "./LangSwitcher.module.less";

export const LangSwitcher: React.FC = observer(() => {
  const location = useLocation();

  const currentLang = i18next.language.toUpperCase();

  const handleLanguageChange = (lang: string) => {
    // Получаем текущий путь
    const pathSegments = location.pathname.split("/");
    pathSegments[1] = lang; // Заменяем язык
    const newPath = pathSegments.join("/");
    // Изменяем язык в i18next
    i18next.changeLanguage(lang);
    // Перезагружаем страницу с новым URL
    window.location.href = newPath;
  };

  const menuItems: MenuProps["items"] = langList.map((langOption) => ({
    key: langOption.value,
    label: langOption.label,
    onClick: () => handleLanguageChange(langOption.value),
  }));

  return (
    <Dropdown
      menu={{ items: menuItems }}
      placement="bottomRight"
      trigger={["click"]}
    >
      <div className={styles.langSwitcher}>{currentLang}</div>
    </Dropdown>
  );
});
